module.exports = __webpack_public_path__ + "static/img/produce-global.1255a6e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productService/publicDetail/produce-global.png
// module id = 0wZT
// module chunks = 34